<p-table [value]="items" (onEditInit)="startEdit($event)" (onEditComplete)="onEditComplete($event)">
  <ng-template pTemplate="header">
    <tr>
      <th class="material-table-cell">Name</th>
      <th>SKU</th>
      <th>Stock</th>
      <th *ngIf="hasArea">Area sqft</th>
      <th>CV qty</th>
      <th>Reserved qty</th>
      <th>Order qty</th>
      <th>Price</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td class="material-table-cell" (click)="clickOnMaterial(rowData.material.name)">
        {{rowData.material.name}}
      </td>
      <td pEditableColumn class="editable-cell sku-cell" *ngIf="canBeEdited">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText blocklateralarrownavigation type="string" class="material-input-text"
                   [(ngModel)]="rowData.material.sku">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.material.sku}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="!canBeEdited">
        {{rowData.vendorCode}}
      </td>

      <td class="stock-cell"
          pTooltip="{{stockMap.has(rowData.cvMaterial.id) ? stockMap.get(rowData.cvMaterial.id) : null}}" tooltipStyleClass="stockInfo-tooltip"
          tooltipPosition="bottom">
        {{rowData.inStockCount}} ({{rowData.cvMaterial?.reservedQuantity}})
      </td>

      <td *ngIf="hasArea">
        {{rowData.material.area | number: '1.2-2'}}
      </td>
      <td pEditableColumn class="editable-cell qty-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.material.estimatedQuantity">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.material.estimatedQuantity | number: '1.0-0'}}
          </ng-template>
        </p-cellEditor>
      </td>

      <td pEditableColumn class="editable-cell qty-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.reservedQuantity">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.reservedQuantity | number: '1.0-0'}}
          </ng-template>
        </p-cellEditor>
      </td>

      <!--      <td *ngIf="!canBeEdited">-->
      <!--        {{rowData.reservedQuantity | number: '1.0-0'}}-->
      <!--      </td>-->

      <td pEditableColumn class="editable-cell qty-cell">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.orderedQuantity">
          </ng-template>
          <ng-template pTemplate="output">
            <!-- {{roundNum(rowData.orderedQuantity)}} -->
            {{rowData.orderedQuantity | number: '1.0-0'}}
          </ng-template>
        </p-cellEditor>
      </td>

      <!--      <td *ngIf="!canBeEdited">-->
      <!--        {{rowData.orderedQuantity | number: '1.0-0'}}-->
      <!--      </td>-->

      <td pEditableColumn class="editable-cell price-cell"
          *ngIf="canBeEdited || orderStatus === 'Confirmed' || orderStatus === 'Delivered'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.price">
          </ng-template>
          <ng-template pTemplate="output">
            <!-- {{roundNum(rowData.price)}} -->
            ${{rowData.price | number: '1.2-2'}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td *ngIf="!canBeEdited && orderStatus !== 'Confirmed' && orderStatus !== 'Delivered'">
        ${{rowData.price | number: '1.2-2'}}
      </td>
    </tr>
  </ng-template>
</p-table>
